var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup254(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 28,
    height: 26,
    transform: "translate(-0.465 0.155)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(-926 -255)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(926 255)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(935.465 267.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M20.387,139.914a2.33,2.33,0,0,1-.6-.077L1.735,135A2.357,2.357,0,0,1,.084,132.14l2.278-8.492a.584.584,0,1,1,1.128.3L1.213,132.44a1.185,1.185,0,0,0,.829,1.435l18.05,4.833a1.163,1.163,0,0,0,1.421-.822l.912-3.379a.584.584,0,0,1,1.128.3l-.911,3.375a2.333,2.333,0,0,1-2.255,1.729",
    transform: "translate(-0.245 -114.224)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M85.019,18.684H66.335A2.338,2.338,0,0,1,64,16.348V2.335A2.338,2.338,0,0,1,66.335,0H85.019a2.338,2.338,0,0,1,2.335,2.335V16.348a2.338,2.338,0,0,1-2.335,2.335M66.335,1.168a1.17,1.17,0,0,0-1.168,1.168V16.348a1.17,1.17,0,0,0,1.168,1.168H85.019a1.17,1.17,0,0,0,1.168-1.168V2.335a1.17,1.17,0,0,0-1.168-1.168Z",
    transform: "translate(-59.568)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M114.335,52.671a2.335,2.335,0,1,1,2.335-2.335,2.338,2.338,0,0,1-2.335,2.335m0-3.5a1.168,1.168,0,1,0,1.168,1.168,1.17,1.17,0,0,0-1.168-1.168",
    transform: "translate(-104.064 -44.497)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M65.7,99.754a.583.583,0,0,1-.413-1L70.8,93.243a1.8,1.8,0,0,1,2.477,0l1.642,1.642,4.545-5.453A1.754,1.754,0,0,1,80.8,88.8h.013a1.75,1.75,0,0,1,1.33.611l6.107,7.126a.584.584,0,1,1-.886.76l-6.107-7.125a.578.578,0,0,0-.444-.2.62.62,0,0,0-.448.21l-4.955,5.945a.583.583,0,0,1-.423.209.562.562,0,0,1-.439-.17l-2.094-2.094a.6.6,0,0,0-.826,0l-5.515,5.515a.582.582,0,0,1-.412.17",
    transform: "translate(-60.602 -82.32)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup254);
export default __webpack_public_path__ + "static/media/Group254.afa774438df4975291c983def9a98ef1.svg";
export { ForwardRef as ReactComponent };